<template>
  <div>
    <Select class="ivu-text-left" v-model="value"  @on-change="change">
      <Option v-for="dict in options" :value="dict.value" :key="dict.value">
        {{dict.label}}
      </Option>
    </Select>
  </div>
</template>

<script type="text/ecmascript-6">
const COMP_NAME = 'DsSelect'
export default {
  name: COMP_NAME,
  props: {
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    selected: {
      type: String,
      default: ''
    },
    label: String
  },
  watch: {
    selected (n) {
      this.value = n
    }
  },
  data () {
    return {
      value: ''
    }
  },
  methods: {
    change (v) {
      this.$emit('on-change', {
        label: this.label,
        value: v
      })
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dsselect/DsSelect.vue